<template>
    <div class="container">
        <div class="banner_box">
            <el-carousel height="375px">
                <el-carousel-item v-for="(item, index) in swiper" :key="index">
                    <img :src="item" alt="">
                </el-carousel-item>
            </el-carousel>
        </div>
        <div class="info_box">
            <div class="tops_box">
                <div class="tab_box">
                    <div class="tab_item" :class="TabCur == index ? 'active_tab' : '' " v-for="(item, index) in TabList" :key="index" @click="TabClick(item, index)">
                        {{ item }}
                    </div>
                </div>

                <div class="desc_box" v-if="TabCur == 0">
                    <div class="desc_item">
                        <span class="label">党组织名称: </span>
                        <span class="value">{{ deptInfo.deptName }}</span>
                    </div>
                    <div class="desc_item">
                        <span class="label">党组织类别: </span>
                        <span class="value">{{ deptInfo.deptType }}</span>
                    </div>
                    <div class="desc_item">
                        <span class="label">党组织书记: </span>
                        <span class="value">{{ deptInfo.leaders }} </span>
                    </div>
                    <div class="desc_item">
                        <span class="label">联系电话: </span>
                        <span class="value">{{ deptInfo.phone }} </span>
                    </div>
                    <div class="desc_item">
                        <span class="label">单位地址: </span>
                        <span class="value">{{ deptInfo.address }} </span>
                    </div>
                </div>

                <div class="fangfei" v-if="TabCur == 1">
                    <div class="user_list" v-for="(item, index) in dangFei" :key="index">
                        {{ item }}
                    </div>
                    <div v-if="!dangFei.length">暂无信息</div>
                </div>

                <div class="rank" v-if="TabCur == 2">
                    <div class="dept_rank" v-for="(item, index) in deptRankList" :key="index">
                        <div class="dept_box">
                            <div class="dept_name">
                                {{ item.userName }}
                            </div>
                            <div class="rank_value">
                               排名: {{ item.rank }}
                            </div>
                        </div>
                    </div>
                    <div v-if="!deptRankList.length">暂无信息</div>
                </div>

            </div>

            <div class="btn_box">
                <div class="btn_item" v-for="(item, index) in BtnList" :key="index" @click="btnClick(item, index)">
                    <div class="icon_box">
                        <span :class="item.iconClass"></span>
                    </div>
                    <div class="btn_name">
                        {{ item.name }}
                    </div>
                </div>
            </div>
        </div>

        <!-- 入党dialog -->
          <div class="dialog_model" v-if="JoinShow">
            <div class="dialog_box">
                <div class="dialog_title">
                    <div class="left">
                        我要入党
                    </div>
                    <div class="right" @click="cancelShenBao">
                        <span class="el-icon-close"></span>
                    </div>
                </div>
                <div class="form_box">
                    <el-form :model="formData" status-icon  ref="ruleForm" label-width="100px" class="demo-ruleForm">
                        <el-form-item label="*姓名" prop="pass">
                            <el-input type="text" v-model="formData.userName" autocomplete="off"></el-input>
                        </el-form-item>
                        <el-form-item label="*性别" prop="pass">
                            <el-select v-model="formData.sex">
                                <el-option v-for="(item, index) in sexList" :key="index" :label="item.name" :value="item.value"></el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item label="*手机号码" prop="pass">
                            <el-input type="text" maxlength="11" v-model.number="formData.phone" autocomplete="off"></el-input>
                        </el-form-item>
                        <el-form-item label="*学历" prop="pass">
                            <el-select v-model="formData.xueLi">
                                <el-option v-for="(item, index) in xue" :key="index" :label="item.dictName" :value="item.dictValue"></el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item label="*民族" prop="pass">
                            <el-select v-model="formData.minZu">
                                <el-option v-for="(item, index) in mz" :key="index" :label="item.mzName" :value="item.mzId"></el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item label="*身份证" prop="pass">
                            <el-input type="text" maxlength="18" v-model="formData.idNumber" autocomplete="off"></el-input>
                        </el-form-item>
                        <el-form-item label="*出生日期" prop="pass">
                            <el-input type="text"  v-model="formData.birthday" autocomplete="off" disabled></el-input>
                            <!-- <el-date-picker
                                v-model="formData.birthday"
                                type="date"
                                placeholder="选择出生日期">
                                </el-date-picker> -->
                        </el-form-item>
                        <el-form-item label="*工作单位" prop="pass">
                            <el-input type="text" v-model="formData.workUnit" autocomplete="off"></el-input>
                        </el-form-item>
                        <el-form-item label="*家庭地址" prop="pass">
                            <el-input type="text" v-model="formData.homeAddress" autocomplete="off"></el-input>
                        </el-form-item>
                        


                        <el-form-item label="申请资料" prop="pass">
                            <el-upload
                            action="https://jsonplaceholder.typicode.com/posts/"
                            list-type="picture-card"
                            :on-change="onChange"
                            :auto-upload="false"
                            >
                            <i class="el-icon-plus"></i>
                            </el-upload>
                            <el-dialog :visible.sync="dialogVisible">
                            <img width="100%" :src="dialogImageUrl" alt="">
                            </el-dialog>
                        </el-form-item>
                        
                        <el-form-item>
                            <el-button class="sub_btn" @click="submitForm">提交</el-button>
                            <el-button class="cel_btn" @click="cancelShenBao">取消</el-button>
                        </el-form-item>
                    </el-form>
                </div>
            </div>
        </div>   

    </div>
</template>

<script>
    import { mapGetters } from "vuex"
    import { checkId, checkPhone } from "../common/checkData"
    export default {
        data() {
            return {
                TabList: ["组织信息", "党费缴纳", "积分排行"],
                TabCur: 0,
                BtnList: [
                    { iconClass: "iconfont icon-shenqingrudang", name: "我要入党" },
                    { iconClass: "iconfont icon-zhuanyi", name: "组织转移", path:"/user/zhuanjie" },
                    { iconClass: "iconfont icon-dangfei", name: "我的党费" , path: "/user/dangfei"},
                    { iconClass: "iconfont icon-xinxiang", name: "书记信箱", path: "/user/shujixinxiang" },
                ],
                JoinShow: false,
                formData: {
                    acceptDeptId: "",
                    userName: "",
                    sex: "",
                    phone: "",
                    xueLi: "",
                    minZu: "",
                    idNumber: "",
                    birthday: "",
                    workUnit: "",
                    homeAddress: "",
                    material: ""
                },
                dialogVisible: false,
                dialogImageUrl: "",
                deptInfo: {},
                deptRankList: [],
                dangFei: [],
                sexList: [{ name: "男", value: '0' }, { name: "女", value: '1' } ],
                mz:[],
                xue: [],
                imgList: [],
                swiper: [],
                defaultImgs: [ require("../../assets/static/index/default.png"),require("../../assets/static/index/default.png"),]
            }
        },
        computed: {
            ...mapGetters(['token']),
            deptId () {
                return this.$route.params.id
            },
            idNumber () {
                return this.formData.idNumber
            },
        },
        watch: {
            deptId () {
                this.getDeptRankList()
                this.getDeptInfo()
                this.getDangFei()
            },
            idNumber () {
                // console.log( this.idNumber )
                if ( this.idNumber && this.idNumber.length == 18 ) {
                    let year = this.idNumber.substr(6,4)
                    let month = this.idNumber.substr(10,2)
                    let day = this.idNumber.substr(12,2)
                    this.formData.birthday = `${year}-${month}-${day}`
                }
            }
        },
        mounted() {
            this.getDeptRankList()
            this.getDeptInfo()
            this.getDangFei()
        },
        created() {
            this.getMinZu()
            this.getXueList()
        },
        methods: {

            // 提交入党资料
            async submitForm () {
                this.formData.acceptDeptId = Number( this.deptId  )
                this.formData.phone = String( this.formData.phone )
                this.formData.minZu = String( this.formData.minZu )
                if ( this.imgList.length ) {
                    this.formData.material = this.imgList.join(",")
                } else {
                    this.formData.material = ""
                }
                let { acceptDeptId, userName, sex, xueLi, minZu, phone, idNumber,birthday,workUnit,homeAddress } = this.formData
                let isMatch = checkId( idNumber )
                let isPhone = checkPhone( phone )
                console.log( isMatch )
                if ( !acceptDeptId ) {
                    return this.$message.error("请选择党组织")
                } else if ( !userName ) {
                    return this.$message.error("请输入你的姓名")
                } else if ( !sex ) {
                    return this.$message.error("请选择你的性别")
                } else if ( !xueLi ) {
                    return this.$message.error("请选择你的学历")
                } else if ( !isPhone ) {
                    return this.$message.error("你输入的手机号码格式有误")
                } else if ( !minZu ) {
                    return this.$message.error("请选择你的民族")
                } else if ( !isMatch ) {
                    return this.$message.error("你输入的身份证格式有误")
                } else if ( !birthday ) {
                    return this.$message.error("请选择你的出生日期")
                }  else if ( !workUnit ) {
                    return this.$message.error("请输入你的工作单位")
                }  else if ( !homeAddress ) {
                    return this.$message.error("请输入你的家庭单位")
                } else {
                    let res = await this.$axios.post("/lencon/pc/deve/rudang", this.formData )
                    if ( res.data.code == 1 ) {
                        this.$message.success( res.data.msg )
                        this.JoinShow = false
                    }
                }
            },

            // 上传图片变化
            async onChange ( files ) {
                console.log( files )
                let filePath = files.raw 
                let FD = new FormData()
                FD.append('circle', filePath)
                FD.append("file_name", "circle")
                let res = await this.$axios.post("/lencon/app/common/upload", FD)
                if ( res.data.code == 1 ) {
                    this.imgList.push( res.data.data[0] )
                }
            },

            // 获取民族
            async getMinZu () {
                let res = await this.$axios.post("/lencon/pc/common/mzLists")
                if ( res.data.code == 1 ) {
                    this.mz = res.data.res
                }
            },
            // x获取学历列表
            async getXueList () {
                let res = await this.$axios.post("/lencon/pc/common/dataList", { type: "education_types" })
                if ( res.data.code == 1 ) {
                    this.xue = res.data.res
                }
            },
            // 点击tab
            TabClick(item, index) {
                this.TabCur = index
            },

            // 点击按钮
            btnClick ( item, index ) {
                if ( index == 0 ) {
                    this.JoinDang()
                } else {
                    this.$router.push( item.path )
                }
            },

            // 点击我要入党
            JoinDang () {
                this.JoinShow = true
            },
            // 关闭dialog
            cancelShenBao () {
                this.JoinShow = false
            },
            // 获取支部人员排名信息 
            async getDeptRankList () {
                this.deptRankList = []
                let { token,deptId } = this 
                let res = await this.$axios.post("/lencon/pc/dept/user_rank", { token, deptId })
                if ( res.data.code == 1 ) {
                    this.deptRankList = res.data.data.slice(0, 5)
                }
            },
            // 获取支部信息
            async getDeptInfo () {
                this.deptInfo = {}
                let { token,deptId } = this 
                let res = await this.$axios.post("/lencon/pc/dept/detail", { token, deptId: Number(deptId) })
                if ( res.data.code == 1 ) {
                    this.deptInfo = res.data.obj
                    this.swiper = this.deptInfo.imgs.length ? this.deptInfo.imgs : this.defaultImgs
                }
            },
            // 获取党费缴纳情况
            async getDangFei () {
                this.dangFei = []
                let { token,deptId } = this 
                let res = await this.$axios.post("/lencon/pc/dept/dues_list", { token, deptId: Number(deptId) })
                if ( res.data.code == 1 ) {
                    this.dangFei = res.data.res.slice(0,5)
                }
            }
        },
    }
</script>
<style>
.el-select-dropdown  {
    z-index: 100000000000000000000000 !important;
}
.el-picker-panel {
    z-index: 100000000000000000000000 !important;
}
</style>

<style lang="scss" scoped>
.container {
    width: 1200px;
    margin: 20px auto;
    display: flex;
    box-sizing: border-box;
    .banner_box {
        width: 627px;
        height: 375px;
        img {
            width: 627px;
            height: 375px;
        }
    }
    .info_box {
        margin-left: 20px;
        flex: 1;
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        // padding: 30px;
        .tops_box {
            background-color: #fff;
            width: 100%;
            padding: 30px;
            height: 287px;
            .tab_box {
                
                width: 100%;
                display: flex;
                align-items: center;
                font-size: 24px;
                font-weight: bold;
                padding-bottom: 10px;
                border-bottom: 1px solid #2767c4 ;
                .tab_item {
                    margin-right: 20px;
                    color: #2767c4 ;
                    position: relative;
                    left: 0;
                    top: 0;
                    width: 120px;
                    text-align: center;
                    cursor: pointer;
                }
                .active_tab {
                    &::after {
                        content: "";
                        width: 120px;
                        height: 4px;
                        background-color: #2767c4 ;
                        position: absolute;
                        left: 0;
                        bottom: -12px;
                    }
                }
            }
            .desc_box {
                padding-top: 20px;
                .desc_item {
                    font-size: 16px;
                    line-height: 33px;
                }
            }
            .rank {
                width: 100%;
                .dept_rank {
                    width: 100%;
                    .dept_box {
                        width: 100%;
                        padding: 8px  20px;
                        display: flex;
                        align-items: center;
                        justify-content: space-between;
                    }
                }
            }

            .fangfei {
                width: 100%;
                padding-top: 20px;
                .user_list {
                    width: 100%;
                    line-height: 30px;
                }
            }
        }

        .btn_box {
            width: 100%;
            padding: 0 30px;
            background-color: #fff;
            height: 80px;
            display: flex;
            justify-content: center;
            align-items: center;
            .btn_item {
                margin: 0 20px;
                text-align: center;
                font-size: 16px;
                color: #2767c4 ;
                font-weight: bold;
                cursor: pointer;
                .icon_box {
                    .iconfont {
                        font-size: 34px;
                    }
                }
                .btn_name {
                    line-height: 30px;
                }
            }
        }
    }

    .dialog_model {
        width: 100%;
        height: 100%;
        position: fixed;
        left: 0;
        top: 0;
        background-color: rgba(0,0,0,.3);
        z-index: 10000000000;
        .dialog_box {
            width: 820px;
            height: 735px;
            overflow-y: scroll;
            position: absolute;
            left: 50%;
            top: 50%;
            margin-left: -410px;
            margin-top: -377px;
            background-color: #fff;
            border-radius: 5px;
            // overflow: hidden;
            padding: 20px;
            .dialog_title {
                font-size: 24px;
                font-weight: bold;
                padding-bottom: 20px;
                border-bottom: 2px solid #2767c4 ;
                color: #2767c4 ;
                display: flex;
                align-items: center;
                justify-content: space-between;
            }
            .form_box {
                padding: 20px 0;
                .sub_btn {
                    width: 230px;
                    height: 50px;
                    color: #fff;
                    background-color: #2767c4 ;
                }
                .cel_btn {
                    width: 230px;
                    height: 50px;
                    color: #fff;
                    background-color: #b3b3b3;
                }
            }
        }
    }
}
</style>